import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        dialog: {
            width: theme.spacing(106),
            maxWidth: 'none !important',
        },
    }
})

export default useStyles
